export default __webpack_public_path__ + "static/media/rewind.61a158c0.svg";